import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Baiao from '../views/Baiao.vue'
import Choro from '../views/Choro.vue'
import Forro from '../views/Forro.vue'
import Frevo from '../views/Frevo.vue'
import Funk from '../views/Funk.vue'
import Hroquenro from '../views/Hroquenro.vue'
import Maracatu from '../views/Maracatu.vue'
import Pagode from '../views/Pagode.vue'
import Samba from '../views/Samba.vue'
import Xote from '../views/Xote.vue'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/baiao',
    name: 'Baiao',
    component: Baiao
  },

  {
    path: '/choro',
    name: 'Choro',
    component: Choro
  },
  {
    path: '/forro',
    name: 'Forro',
    component: Forro
  },

    {
    path: '/frevo',
    name: 'Frevo',
    component: Frevo
  },

  {
    path: '/funk',
    name: 'Funk',
    component: Funk
  },

    {
    path: '/hroquenro',
    name: 'Hroquenro',
    component: Hroquenro
  },

    {
    path: '/maracatu',
    name: 'Maracatu',
    component: Maracatu
  },

    {
    path: '/pagode',
    name: 'Pagode',
    component: Pagode
  },

  {
    path: '/samba',
    name: 'Samba',
    component: Samba
  },

  {
    path: '/xote',
    name: 'Xote',
    component: Xote
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
